module.exports = __webpack_public_path__ + "img/user13.22a25469.jpg";